import { TmBaseError } from '@/core/error/tmBaseError'

export class TmFilterStrategyManagerError extends TmBaseError {
  public name = 'TmFilterStrategyManagerError'
}
